var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddPetImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5879 7.9741C13.59 8.30475 13.5879 8.25832 13.5879 8.64231C13.5879 9.299 13.5879 9.87347 13.5774 10.3801C13.546 11.8967 13.4207 12.8059 12.9201 13.4949C12.7044 13.7917 12.4434 14.0528 12.1465 14.2685C11.2274 14.9363 9.91623 14.9363 7.29395 14.9363C4.67166 14.9363 3.36051 14.9363 2.44136 14.2685C2.15529 14.0606 1.90246 13.8106 1.69146 13.5271C1.68351 13.5164 1.67562 13.5057 1.6678 13.4949C1 12.5757 1 11.2646 1 8.64231C1 6.02002 1 4.70887 1.6678 3.78973C1.88347 3.49288 2.14452 3.23183 2.44136 3.01616C3.36051 2.34836 4.67166 2.34836 7.29395 2.34836C8.20319 2.34836 8.11093 2.34766 8.11093 2.34766",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45334 7.78559C4.68089 7.78559 4.05469 7.15939 4.05469 6.38694C4.05469 5.61448 4.68089 4.98828 5.45334 4.98828C6.2258 4.98828 6.852 5.61448 6.852 6.38694C6.852 7.15939 6.2258 7.78559 5.45334 7.78559Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96208 14.9365C9.58437 14.9365 10.8955 14.9365 11.8147 14.1773C12.1115 13.9322 12.3726 13.6354 12.5882 13.2979C13.0888 12.5147 13.2141 11.481 13.2455 9.7569C12.7182 9.15736 12.456 9.10957 12.2176 8.9171C10.7149 7.70415 8.6262 8.25645 7.46389 9.88237C7.32352 10.0787 7.183 10.3404 6.96208 10.7796L6.59969 10.6507C5.76363 10.4606 5.3456 10.3655 4.96193 10.3748C3.93515 10.3996 2.9826 10.452 2.33501 11.3581C2.09303 11.6968 1.90238 12.1302 1.52107 12.9972L1.44427 13.1718L1.3596 13.3345C1.5706 13.6568 1.82343 13.941 2.1095 14.1773C3.02865 14.9365 4.3398 14.9365 6.96208 14.9365Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2578 1.0625V4.98797",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3594 3.02344H15.1535",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPetImage);
export default __webpack_public_path__ + "static/media/add-pet-image.dc2cae86.svg";
export { ForwardRef as ReactComponent };